webpackJsonp([3],{

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(2);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	__webpack_require__(29);
	
	var _common = __webpack_require__(30);
	
	var _common2 = _interopRequireDefault(_common);
	
	var _hirekMorzsamenu = __webpack_require__(284);
	
	var _hirekMorzsamenu2 = _interopRequireDefault(_hirekMorzsamenu);
	
	var _kapcsolat = __webpack_require__(288);
	
	var _kapcsolat2 = _interopRequireDefault(_kapcsolat);
	
	var _news = __webpack_require__(364);
	
	var _news2 = _interopRequireDefault(_news);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_angular2.default.module('ANEW-app', [_common2.default, _hirekMorzsamenu2.default, _kapcsolat2.default, _news2.default]).constant('environment', window.__env).config(["$locationProvider", function ($locationProvider) {
		'ngInject';
	
		$locationProvider.hashPrefix('');
	}]);
	_angular2.default.bootstrap(document, ['ANEW-app']);

/***/ }),

/***/ 284:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var MODULE_NAME = 'hirekMorzsamenu';
	
	var HirekMorzsamenuController = function HirekMorzsamenuController($scope) {
		'ngInject';
	
		var _this = this;
	
		_classCallCheck(this, HirekMorzsamenuController);
	
		$scope.$on('hirekMorzsamenuChange', function (e, value) {
			_this.hirCim = value;
		});
	};
	HirekMorzsamenuController.$inject = ["$scope"];
	
	exports.default = angular.module(MODULE_NAME, []).controller('hirekMorzsamenuController', HirekMorzsamenuController).name;

/***/ }),

/***/ 364:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var MODULE_NAME = 'news';
	
	var NewsController = function () {
		NewsController.$inject = ["$document"];
		function NewsController($document) {
			'ngInject';
	
			_classCallCheck(this, NewsController);
	
			this._$document = $document;
		}
	
		_createClass(NewsController, [{
			key: '$onInit',
			value: function $onInit() {
				this.shareUrl = encodeURIComponent(this._$document[0].URL);
			}
		}]);
	
		return NewsController;
	}();
	
	angular.module(MODULE_NAME, []).controller('NewsController', NewsController);
	
	exports.default = MODULE_NAME;

/***/ })

});


// WEBPACK FOOTER //
// layouts/ANEW/layout.bundle.js